class AddLine {
    constructor() {
        this.groups = []
    }
    addGroup(id, positions, color, width, style = "Glow", opacity = 1) {
        const g = this.getById(id)
        if (g) {
            this.setShowById(id)
        } else {
            const group = { id: id, containers: [] }
            this.groups.push(group)
            for (let i = 0; i <= positions.length - 1; i++) {
                const line = this.addLine(positions[i], color, width, style, opacity)
                group.containers.push(line)
            }
        }
    }
    addLine(position, color = "#90EE90", width = 12, style = "Glow", opacity = 1) {
        const line = new map3d.Entity.Line({
            position: position,
            opacity: opacity,
            width: width,
            style: style,
            glowPower: 0.1,
            color: color,
        })
        line.setShow(true)
        return line
    }
    getById(id) {
        let result
        this.groups.forEach((item) => {
            if (item.id === id) {
                result = item
            }
        })
        return result
    }
    setShowById(id, show) {
        const linegroup = this.getById(id)
        linegroup.containers.forEach((item) => {
            item.setShow(show)
        })
    }
}
export default new AddLine()




// WEBPACK FOOTER //
// ./src/mapfunction/AddLine.js